export enum TariffTypeCodes {
    Demurrage = '03',
    TerminalSecurityCharge = '17',
    ElectricityCosts = 'TS',
    WaterCosts = 'TV',
    Other = '14'
}
